var _linearGradient, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRemind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dL-mBE-1ZiRfH_igXjFxca",
    x1: 24,
    x2: 24,
    y1: 1064.905,
    y2: 1009.836,
    gradientTransform: "translate(0 -1014)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#0080e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#009ced"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00b0f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b5f2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dL-mBE-1ZiRfH_igXjFxca)",
    d: "M13.5,6h21c4.142,0,7.5,3.358,7.5,7.5v21c0,4.142-3.358,7.5-7.5,7.5h-21 C9.358,42,6,38.642,6,34.5v-21C6,9.358,9.358,6,13.5,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.644,17.513C30.974,15.408,27.983,14,24.558,14c-4.113,0-7.604,2.028-8.922,4.859 c-3.097,1.089-5.194,4.336-4.505,7.967c0.508,2.678,2.611,4.853,5.248,5.43c1.948,0.426,3.788,0.008,5.252-0.945l0.424,4.249 c0.045,0.449,0.617,0.602,0.876,0.235l3.419-4.858c0.083,0.004,0.16,0.024,0.244,0.024c2.096,0,3.89-1.259,4.715-3.065 c0.163,0.016,0.321,0.05,0.488,0.05c2.873,0,5.203-2.355,5.203-5.26C37,20.074,35.111,17.924,32.644,17.513z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemind);
export default __webpack_public_path__ + "static/media/ic_remind.906fe4773253f33a5076a93b61a2a85e.svg";
export { ForwardRef as ReactComponent };